export default __webpack_public_path__ + "static/media/symbols_help-outline.8c653ab4.svg";